var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavRightArrowDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53404 1.40683C2.23012 0.718214 3.35264 0.72427 4.04126 1.42035L9.33118 6.76766C10.0198 7.46374 10.0137 8.58626 9.31766 9.27488L3.97035 14.5648C3.27427 15.2534 2.15175 15.2474 1.46313 14.5513C0.774517 13.8552 0.780572 12.7327 1.47666 12.0441L5.56359 8.00098L1.52051 3.91405C0.831899 3.21796 0.837955 2.09544 1.53404 1.40683Z",
    fill: "#329EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRightArrowDark);
export default __webpack_public_path__ + "static/media/nav-right-arrow-dark.a94c358b92eda3aad3895d89dfc513e2.svg";
export { ForwardRef as ReactComponent };